import InfinitePartnersList from './infinite-partner-list';

export default InfinitePartnersList;
